import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";

import StyledModal from "components/Modal";
import { FormInput } from "components/FormInput";

import { FormValues, validationSchema } from "./validation";

import { useAppDispatch } from "store/hooks";
import {
  getSubscriptionPromocode,
  SubscriptionKeys,
} from "store/features/subscriptionSlice";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface PromoCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PromoCodeModal: React.FC<PromoCodeModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();

  const methods = useForm<FormValues>({
    mode: "onSubmit",
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.promocode_submit,
      null,
      true
    );

    await methods.handleSubmit(async (values: FormValues) => {
      const data = await dispatch(
        getSubscriptionPromocode(values.promocode)
      ).unwrap();

      if (data.isActive) {
        localStorage.setItem(
          SubscriptionKeys.PROMOCODE,
          data.code.toUpperCase()
        );
        localStorage.setItem(
          SubscriptionKeys.PROMOCODE_TIMESTAMP,
          Date.now().toString()
        );
        onCloseModal();
      } else {
        methods.setError("promocode", {
          type: "manual",
          message: "Промокод недійсний або більше не активний.",
        });
      }
    })();
  };

  const onCloseModal = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.promocode_close_modal,
      null,
      true
    );
    methods.reset();
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title="Використати промокод"
      content={
        <FormProvider {...methods}>
          <FormInput title="Промокод" name="promocode" fullWidth />
        </FormProvider>
      }
      onAction={onSubmit}
      actionBtnText="Застосувати"
    />
  );
};

export default PromoCodeModal;
